module.exports = __webpack_public_path__ + "static/media/wechatpay.c3855876.svg";